export default function StandupSection() {
  return (
    <section id="standup" className="py-20 md:py-28 bg-gradient-to-br from-[#c8963e] to-[#a87830] overflow-hidden">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row gap-12 items-center">
          {/* Image */}
          <div className="w-full lg:w-[45%] relative">
            <div className="rounded-2xl overflow-hidden h-72 md:h-96 lg:-my-10">
              <img
                src="/img/standup-main.jpg"
                alt="Смехосоматика"
                className="w-full h-full object-cover object-top"
              />
            </div>
          </div>

          {/* Text */}
          <div className="w-full lg:w-[55%] text-white">
            <div className="inline-flex items-center gap-2 bg-white/20 rounded-full px-4 py-2 mb-6">
              <span className="text-sm font-semibold">🎤 Медицинский стендап</span>
            </div>

            <h2 className="text-3xl md:text-5xl font-extrabold mb-6 leading-tight">
              Пауза для<br />медицинского юмора
            </h2>

            <div className="space-y-4 text-white/90 text-base md:text-lg leading-relaxed mb-8">
              <p>
                Комики «Смехосоматика» превращают врачебный быт в комедию. Истории из реальной практики, которые вы узнаёте — и смеётесь, потому что это правда.
              </p>
              <p>
                Пять выступлений за два дня — между секциями, когда голова уже полна информации. Именно тогда смех работает лучше всего.
              </p>
              <p>
                Профилактика выгорания через юмор — это не шутка. Это наука.
              </p>
            </div>

            <div className="flex flex-wrap gap-4">
              <div className="bg-white/20 backdrop-blur-sm rounded-2xl px-6 py-4 text-center">
                <div className="text-3xl font-extrabold">5</div>
                <div className="text-sm text-white/80 mt-1">выступлений</div>
              </div>
              <div className="bg-white/20 backdrop-blur-sm rounded-2xl px-6 py-4 text-center">
                <div className="text-3xl font-extrabold">15</div>
                <div className="text-sm text-white/80 mt-1">минут каждое</div>
              </div>
              <div className="bg-white/20 backdrop-blur-sm rounded-2xl px-6 py-4 text-center">
                <div className="text-3xl font-extrabold">2</div>
                <div className="text-sm text-white/80 mt-1">дня смеха</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
